import { createContext } from 'react'
import { cn } from '@/lib/utils'
import { useBreakpoint } from 'app/frontend/base/hooks/useBreakpoint'
import CandidateRoleBlock from './CandidateRoleBlock'
import { useCandidatesByRole } from '../hooks'

type Props = {
  candidates: wowaudit.GuildCandidate[]
  className?: string
}

export const CandidateSetupContext = createContext<{
  candidatesByRole: Record<string, wowaudit.GuildCandidate[]>
}>({
  candidatesByRole: {},
})

const CandidateSetup = ({ candidates, className }: Props) => {
  const breakpoint = useBreakpoint()
  const candidatesByRole = useCandidatesByRole(candidates)

  return (
    <CandidateSetupContext.Provider value={{ candidatesByRole }}>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3'>
        {['sm', 'md'].includes(breakpoint) ? (
          <>
            <div className='flex flex-col gap-3'>
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'tank'}
              />
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'ranged'}
              />
            </div>
            <div className='flex flex-col gap-3'>
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'heal'}
              />
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'melee'}
              />
            </div>
          </>
        ) : (
          <>
            <div className='flex flex-col gap-3'>
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'tank'}
              />
              <CandidateRoleBlock
                className={cn(className, 'grow')}
                role={'heal'}
              />
            </div>
            <CandidateRoleBlock className={className} role={'melee'} />
            <CandidateRoleBlock className={className} role={'ranged'} />
          </>
        )}
      </div>
    </CandidateSetupContext.Provider>
  )
}

export default CandidateSetup
